/**
 * Wrapper around native fetch to automatically include CSRF token
 */
export const fnfetch = async (url, options = {}) => {
  const method = options.method || 'GET'
  const isStateChanging = !['GET', 'HEAD', 'OPTIONS'].includes(method.toUpperCase())

  if (isStateChanging) {
    const csrfToken = document.cookie
      .split('; ')
      .find(row => row.startsWith('csrfToken='))
      ?.split('=')[1]

    if (csrfToken) {
      options.headers = {
        ...options.headers,
        'x-csrf-token': csrfToken
      }
    }
  }

  const res = await fetch(url, options)

  if (res.status === 401) {
    const { user } = await import('./state.js')
    user({ loggedIn: false })
  }

  return res
}
